import { render, staticRenderFns } from "./TaskNewDialogDetail.vue?vue&type=template&id=746c6ce6&scoped=true"
import script from "./TaskNewDialogDetail.vue?vue&type=script&lang=js"
export * from "./TaskNewDialogDetail.vue?vue&type=script&lang=js"
import style0 from "./TaskNewDialogDetail.vue?vue&type=style&index=0&id=746c6ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c6ce6",
  null
  
)

export default component.exports